import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import i18n from "i18next";
import Cookies from "js-cookie";
import logo from "../img/logo.png";
import logo_mob from "../img/logo.png";
import MobileMenu from "./MobileMenu";

function Header() {
  const location = useLocation();

  const { t } = useTranslation();

  const languages = [{ value: "en", label: "EN" }];

  const storedLang = Cookies.get("i18next");
  const [currentLang, setCurrentLang] = useState(storedLang || "en");

  // state для фона при скролле
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    if (storedLang && storedLang !== currentLang) {
      setCurrentLang(storedLang);
      i18n.changeLanguage(storedLang);
    }
    document.body.setAttribute("dir", storedLang === "ar" ? "rtl" : "ltr");
    // eslint-disable-next-line
  }, [storedLang]);

  const handleChangeLang = (selectedLang) => {
    setCurrentLang(selectedLang.value);
    i18n.changeLanguage(selectedLang.value);
    Cookies.set("i18next", selectedLang.value);
  };

  // слушаем скролл
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // функция для определения цвета текста
  const getLinkClass = (path) => {
    if (location.pathname === path) {
      return "text-[#FC2E00]"; // активная страница красная
    }
    if (location.pathname === "/about-us" && !isScrolled) {
      return "xl:text-[#FFFFFFB2]"; // белый на about-us без скролла
    }
    return "text-[#000000B2]"; // стандартный цвет
  };

useEffect(() => {
  const handleScroll = () => {
    if (location.pathname === "/about-us" && window.scrollY <= 200) {
      document.body.classList.add("about-us-page");
    } else {
      document.body.classList.remove("about-us-page");
    }
  };

  window.addEventListener("scroll", handleScroll);
  handleScroll(); // проверить сразу при загрузке

  return () => window.removeEventListener("scroll", handleScroll);
}, [location.pathname]);


  return (
    <div className="header-container fixed top-0 left-0 w-full z-50 overflow-hidden">
      {/* Desktop */}
      <div
        className="max-w-[1220px] h-[60px] xl:h-[72px] justify-between mx-auto flex items-center px-[20px] transition-colors duration-1000"
        style={{
          background:
            location.pathname === !isScrolled
              ? "transparent"
              : isScrolled
              ? "#F4F1E8"
              : "linear-gradient(90deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.00) 100%)",
        }}
      >
        <Link to="/">
          <img src={logo} alt="" className="w-[32px] xl:w-[54px]" />
        </Link>
        <div className="flex items-center gap-[20px]">
          <Link to="/about-us">
            <p
              className={`text-[16px] font-[500] host-grotesk transition-all ${getLinkClass(
                "/about-us"
              )}`}
            >
              {t("header.1")}
            </p>
          </Link>
          <Link to="/consultation">
            <p
              className={`text-[16px] font-[500] host-grotesk transition-all ${getLinkClass(
                "/consultation"
              )}`}
            >
              {t("header.2")}
            </p>
          </Link>
          <Dropdown
            options={languages}
            placeholder="EN"
            onChange={handleChangeLang}
            value={languages.find((lang) => lang.value === currentLang)}
          />
        </div>
      </div>
    </div>
  );
}

export default Header;
